import { useLazyQuery, useMutation } from '@apollo/client';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import MaterialsContainer from '../../components/MaterialsContainer/MaterialsConatiner';
import FileUpload from '../../components/Popups/FileUpload';
import './ImageMaterial.scss';
import { useCallback, useEffect, useState } from 'react';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { DELETE_IMAGES_PODCASTS, DELETE_IMAGES_PODCASTS_ADMIN, EDIT_IMAGE_OR_PODCAST, UPDATE_IMAGES_PODCASTS, UPDATE_IMAGES_PODCASTS_ADMIN, UPLOAD_LIBRARY_IMAGE, UPLOAD_LIBRARY_IMAGE_ADMIN, VIEW_ALL_LIBRARY_IMAGES, VIEW_ALL_LIBRARY_IMAGES_ADMIN } from './api/ImageMaterialQuery';
import { useAppSelector } from '../../redux/app/hooks';
import ImageViewer from '../../components/ImageViewer/ImageViewer';
import { materialsData } from '../../utils/interface';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, IMAGE_MATERIAL_TEXT, MYLIBRARY_TEXTS, PATH_ADDRESSES, SCHOOL_ADMIN, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE } from '../../utils/constants';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import { UploadedFilePayload } from '../SyndicatedVideos/SyndicatedVideos';
import UploadResultModal, { UploadResult, UploadResultForTeacher } from '../AdminBulkUpload/components/UploadResultModal';

const ImageMaterial = () => {
    const [url, setUrl] = useState<string>();
    const [imgFileData, setImgFileData] = useState<materialsData | undefined>();
    const [filename, setFilename] = useState<string>();
    const [fileData, setFileData] = useState<File | null>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openPdf, setOpenPdf] = useState(false);
    const role = useAppSelector((state) => state.auth.role);
    const [imageMaterialsData, setImageMaterialsData] = useState<[materialsData]>();
    const backNavigation = role === SCHOOL_ADMIN  ?  "/admin-materials-upload/materials/images" : role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_IMAGES_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_IMAGES_PATH;
    const [searchValue, setSearchValue] = useState<string>('');
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedClassId = useAppSelector((state) => state?.auth?.selectedClassRoomId);
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [refetch, SetRefetch] = useState<boolean>(false);
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const {uploadCloud} = images;
    const selectedClassroomIdAdmin = useAppSelector(
        (state) => state.CommonUpload.classroomId
      );
    const [isEditImage, setIsEditImage] = useState<boolean>(false);
    const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);

    const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
    const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [successCount, setSuccessCount] = useState<number>(0);
    const [failureCount, setFailureCount] = useState<number>(0);
    const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
    const [upoloadResultsForTeacher, setUploadResultsForTeacher] = useState<UploadResultForTeacher>();
    const [isModalOpen, setIsModalOpen] = useState(false);    


    const [uploadImageMaterial] = useMutation(UPLOAD_LIBRARY_IMAGE, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMultipleMylibraryImagesAndPodcasts?.json) {
                setUploadedPayloads([]);
                const result = data?.uploadMultipleMylibraryImagesAndPodcasts?.json || {};
                setUploadResultsForTeacher(result);

                const hasFailures =
                result.failed_count > 0 ||
                result.results.some((item: any) => item.status === "error");

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                getAllImageMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        cId: selectedClassId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                    }
                });
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [editImage] = useMutation(EDIT_IMAGE_OR_PODCAST, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            console.log("edit images data",data);
           if(data?.editMylibraryImageOrPodcast) {
                setFileData(null);
                if(!(fileData && url)) {
                    success("File updated successfully!");
                }
                if(fileData && url) {
                    if (filename) {
                        setUploadFileName(filename);
                    }
                    setuploaded(true);
                    setUploadProgress(100);
                }
                setFilename('');
                setUrl('');
                setHasSubmittedForEdit(false);
                setMaterialAction('');
                if(role === SCHOOL_ADMIN){
                    getAllImageMaterialAdmin({
                        variables: {
                            subjectId: selectedSubjectId,
                            searchInput: `%${searchValue.trim()}%`,
                            classroomIds: [selectedClassroomIdAdmin],
                        },
                    });
                } else {
                    getAllImageMaterial({
                        variables: {
                            lId: selectedLibraryId,
                            sjId: selectedSubjectId,
                            cId: selectedClassId,
                            limit: null,
                            offset: null,
                            searchInput: `%${searchValue.trim()}%`,
                        }
                    });
                }
           }
        },
        onError: (err) => {
            error(err?.message);
            if (filename) {
                setUploadFileName(filename);
            }
            if(fileData && url) {
                setuploaded(true);
                setUploadProgress(0);
                setUploadFailed(true);
            }
        }
    });

     const [uploadImageMaterialAdmin] = useMutation(UPLOAD_LIBRARY_IMAGE_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.uploadMylibraryImagesBySchoolAdmin) {
                setUploadedPayloads([]);
                const result = data.uploadMylibraryImagesBySchoolAdmin?.result || [];
                setUploadResults(result);
                const hasFailures = result.some(
                    (res: UploadResult) => res.classrooms_failed.length > 0
                );
                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                getAllImageMaterialAdmin({
                  variables: {
                    subjectId: selectedSubjectId,
                    searchInput: `%${searchValue.trim()}%`,
                    classroomIds: [selectedClassroomIdAdmin],
                  },
                });
            }
        },
        onError: (err) => {
            setUploadedPayloads([]);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    const [getAllImageMaterial, { loading }] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMylibraryImagesPodcastsInfo?.nodes) {
                setImageMaterialsData(data?.getMylibraryImagesPodcastsInfo?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
                    }
                }, 2000);
            }
        }
    });

    const [getAllImageMaterialAdmin, { loading: AdminLoading }] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES_ADMIN, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            if (data?.getMylibraryImagesForAdmin?.nodes) {
                setImageMaterialsData(data?.getMylibraryImagesForAdmin?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(imageMaterialsData && imageMaterialsData.length > 0){
        imageMaterialsData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[imageMaterialsData, profile?.getCurrentUser?.nodes, readFeed, role])

    const [updateImage] = useMutation(UPDATE_IMAGES_PODCASTS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            if(materialAction === "share"){
                success("Shared successfully");
            }else if(materialAction === "undoShare"){
                success("Unshared successfully");
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
                    }
                }, 2000);
            }
        }
    });

    const [updateImageAdmin] = useMutation(UPDATE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            if(materialAction === "share"){
                success("Shared successfully");
            }else if(materialAction === "undoShare"){
                success("Unshared successfully");
            }
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    const [deleteImage] = useMutation(DELETE_IMAGES_PODCASTS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
                    } else {
                        navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
                    }
                }, 2000);
            }
        }
    });

     const [deleteImageAdmin] = useMutation(DELETE_IMAGES_PODCASTS_ADMIN, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: () => {
            SetRefetch(!refetch);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
            console.error(err?.message)
        }
    });

    useEffect(() => {
         if(role === SCHOOL_ADMIN){
         getAllImageMaterialAdmin({
           variables: {
             subjectId: selectedSubjectId,
             searchInput: "%%",
             classroomIds: [selectedClassroomIdAdmin],
           },
         });
        }else{
        getAllImageMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: `%${searchValue.trim()}%`,
                isClassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }
    }, [refetch]);

    useEffect(() => {
        if(role === SCHOOL_ADMIN){
         getAllImageMaterialAdmin({
           variables: {
             subjectId: selectedSubjectId,
             searchInput: '%%',
             classroomIds: [selectedClassroomIdAdmin],
           },
         });
        }
        else{
        getAllImageMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: '%%',
                isClassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        })
        }
    }, []);

    useEffect(() => {
        if(materialAction === 'edit' && (hasSubmittedForEdit)){
            console.log("ready to call the edit api", fileData, filename, url);
            let newFileName;
            let newFilePath;
            let newFileSize;

            if(filename !== imgFileData?.filename){
                newFileName = filename?.replace(/\.pdf$/, "")?.trim();
            }
            if(url && fileData) {
                newFilePath = url;
                newFileSize = fileData?.size;
            }

            editImage({
                variables: {
                    fileId: imgFileData?.fileId, 
                    classroomId: (role === SCHOOL_ADMIN) ? [selectedClassroomIdAdmin] : selectedClassId,
                    subjectId: selectedSubjectId,
                    fileType: MYLIBRARY_TEXTS?.IMAGES_TEXT,
                    ...(newFileName && { newFilename: newFileName }),
                    ...(newFilePath && newFileSize && { newFilepath: newFilePath }),
                    ...(newFilePath && newFileSize && { newFilesize: newFileSize })
                }
            });
        }
    }, [fileData, filename, url, hasSubmittedForEdit]);

    const formatUploadedPayloads = (
        uploadedPayloads: UploadedFilePayload[]
    ) => {

      return uploadedPayloads.map((item) => {
    
        return {
            filename: item.filename?.replace(/\.pdf$/, "")?.trim(),
            filepath: item.filepath,
            filesize: item.filesize,
            isClassroom: false,
            coverImagePath: null,
            fileDescription: null
        };
        });
        };
    
        useEffect(() => {
            if(uploadedPayloads.length > 0 ){
                const updatedFormattedPayload = formatUploadedPayloads(
                    uploadedPayloads
                );
    
                if(role === SCHOOL_ADMIN){
                    uploadImageMaterialAdmin({
                        variables: {
                        files: updatedFormattedPayload,
                        classroomIds: [selectedClassroomIdAdmin],
                        subjectId: selectedSubjectId,
                        },
                    });
                } else if(role === TEACHER_ROLE) {
                    uploadImageMaterial({
                        variables: {
                            libraryId: selectedLibraryId,
                            classroomId: selectedClassId,
                            subjectId: selectedSubjectId,
                            files: updatedFormattedPayload
                        }
                    })
                }
            }
        }, [ uploadedPayloads ]);

    //To open pdf in detailed view
    const handleOpenFile = (imgData: materialsData) => {
        setOpenPdf(true);
        setImgFileData(imgData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setOpenPdf(false);
        setImgFileData(undefined);
        if(role === SCHOOL_ADMIN){
         getAllImageMaterialAdmin({
           variables: {
             subjectId: selectedSubjectId,
             searchInput: `%${searchValue.trim()}%`,
            classroomIds: [selectedClassroomIdAdmin],
           },
         });
        }
        else{
        getAllImageMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: `%${searchValue.trim()}%`,
                isClassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }
    }

    //To done actions in materials
    const handleMaterialActions = (data:any,action:string) =>{
        if(action === "share"){
            setMaterialAction("share");
            if(role === SCHOOL_ADMIN){
              updateImageAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: true,
                    pLType: MYLIBRARY_TEXTS?.IMAGES_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateImage({
                variables:{
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassId,
                    fId: data?.fileId
                }
            });
            }
        }else if(action === "undoShare"){
            setMaterialAction("undoShare");
             if(role === SCHOOL_ADMIN){
              updateImageAdmin({
                variables: {
                  input: {
                    pSubjectId: selectedSubjectId,
                    pFileId: data?.fileId,
                    pIsClassroom: false,
                    pLType: MYLIBRARY_TEXTS?.IMAGES_TEXT,
                    pClassroomIds: [selectedClassroomIdAdmin],
                  },
                },
              });
            }else{
            updateImage({
                variables:{
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassId,
                    fId: data?.fileId
                }
            });
            }
        }else if(action === "delete"){
            setMaterialAction('');
            if(role === SCHOOL_ADMIN){
                deleteImageAdmin({
                  variables: {
                    input: {
                      pSubjectId: selectedSubjectId,
                      pFileId: data?.fileId,
                      pLType: MYLIBRARY_TEXTS?.IMAGES_TEXT,
                      pClassroomIds: [selectedClassroomIdAdmin],
                    },
                  },
                });
            }else{
            deleteImage({
                variables:{
                    cId: selectedClassId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                }
            });
            }
        } else if(action === "edit"){
            setMaterialAction("edit");
            setIsEditImage(true);
            setOpen(true);
            setIsUploadOpen(true);
            setImgFileData(data);
        }

    };

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setSearchValue(value);
            if(role === SCHOOL_ADMIN){
              getAllImageMaterialAdmin({
                variables: {
                  subjectId: selectedSubjectId,
                  searchInput: `%${value.trim()}%`,
                 classroomIds: [selectedClassroomIdAdmin],
                },
              });
            }
        else{
            getAllImageMaterial({
                variables:{
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId:selectedClassId,
                    limit: null,
                    offset: null,
                    searchInput: `%${value.trim()}%`,
                    isClassroom: role === STUDENT_ROLE ? true : [true, false],
                }
            });
        }
        }, 500),
        [getAllImageMaterial]
    );

    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    return (
        <div className={`imageMaterial ${role === SCHOOL_ADMIN ? "schoolAdminMaterials":""}`}>
            <LibraryHeader
                image={openPdf ? '' : state?.imageSrc}
                subject={openPdf ? '' : state?.title}
                backgroundColor={state?.backGroundColor}
                subCategory={openPdf ? '' : MYLIBRARY_TEXTS?.IMAGES_TEXT}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openPdf}
                onClose={handleClosePdf}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />
            {
                openPdf ?
                    <ImageViewer file={imgFileData?.filepath ? baseUrl + imgFileData?.filepath : ''} imgFileData={imgFileData} onClose={handleClosePdf} type={MYLIBRARY_TEXTS?.IMAGES_TEXT} />
                    :
                    <>
                        <div className='imageMaterialBody' style={{height: role=== STUDENT_ROLE? '92%' : ''}}>
                            {
                                loading || AdminLoading ? <Loader bottom='110px' />
                                    :
                                    <MaterialsContainer
                                        subject={state?.title}
                                        subCategory={MYLIBRARY_TEXTS?.IMAGES_TEXT}
                                        materialsData={imageMaterialsData}
                                        handleOpenFile={handleOpenFile}
                                        isPdf={false}
                                        handleMaterialActions={handleMaterialActions}
                                    />
                            }
                        </div>
                    </>
            }
            {/* {isUploadOpen && <FileUpload type='image' name='ImageMaterial' setUrl={setUrl} open={open} setOpen={setOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} />} */}
            {isUploadOpen && !isEditImage && <CommonBulkUpload page={MYLIBRARY_TEXTS?.IMAGES_TEXT} type='image' name={IMAGE_MATERIAL_TEXT} setUploadedPayloads = {setUploadedPayloads} setFilesStatusData = {setFilesStatusData} setTotalProgress = {setTotalProgress} setSuccessCount = {setSuccessCount} setFailureCount = {setFailureCount} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName} />}
            {isUploadOpen && isEditImage && imgFileData && <FileUpload page={MYLIBRARY_TEXTS?.IMAGES_TEXT} type='image' setHasSubmittedForEdit={setHasSubmittedForEdit} setMaterialAction={setMaterialAction} selectedFileData = {imgFileData} isEdit = {isEditImage} setIsEdit = {setIsEditImage} name={IMAGE_MATERIAL_TEXT} setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName} />}
            {uploaded && <UploadToaster successCount = {successCount} failureCount={failureCount} FilesStatusData = {FilesStatusData} setFilesStatusData = {setFilesStatusData} totalProgress = {totalProgress} setTotalProgress = {setTotalProgress} uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}
            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForTeacher}
                page='ImagesDirectClass'
            />
             {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openPdf &&
                <div className='libraryHeaderUploadContainer'> 
                    <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                        <img src={uploadCloud} alt="upload" className='uploadImage' />
                    </div>
                </div>}
        </div>
    )
}

export default ImageMaterial;
